import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-standard-page-content-grid',
  templateUrl: 'standard-page-content-grid.component.html',
  styleUrls: ['standard-page-content-grid.component.scss'],
  standalone: false,
})
export class StandardPageContentGridComponent {
  @Input() flexGrow = true;

  @HostBinding('class') get cssClass() {
    return (
      'card-body card-body-grid vertical' +
      (this.flexGrow ? ' flex-grow-1' : ' flex-grow-0') +
      this.customCssClass
    );
  }

  private customCssClass = '';

  constructor(private cd: ChangeDetectorRef) {}

  addCssClass(cssClass: string) {
    if (!new RegExp(` ${cssClass}( |$)`).test(this.customCssClass)) {
      setTimeout(() => {
        this.customCssClass += ' ' + cssClass;
        this.cd.markForCheck();
      });
    }
  }
}
